import { createFromRawValue, State, TrackedArray, TrackedRecord } from "@aidkitorg/typesheets/lib/collab";
import { useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { InfoDict } from "./Questions/Props";


export function PersonaModal({
    state,
    mockInfo,
    showModal,
    setShowModal,
    activePersonaName,
    setActivePersonaName
  }: {
    state: State,
    mockInfo: InfoDict,
    showModal: boolean,
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
    activePersonaName?: string,
    setActivePersonaName: React.Dispatch<React.SetStateAction<string>>
  }) {
    const [newPersonaName, setNewPersonaName] = useState("");

    async function saveNewPersona() {
        const personaAttrs = Object.keys(mockInfo).map((k) => {
            return {
                field: k,
                value: mockInfo[k] ? mockInfo[k] : '',
            };
        });

        const personas = (((state as State).workingSet['root'] as TrackedRecord).value['personas'] as TrackedArray);
        const newPersona = createFromRawValue(state as State, {
            kind: 'Persona',
            name: newPersonaName,
            attrs: personaAttrs,
            });
        
        personas.insert(0, newPersona);
        setActivePersonaName(newPersonaName);
        setNewPersonaName('');
        setShowModal(false);
    }

    async function updateActivePersona() {
        const personaAttrs = Object.keys(mockInfo).map((k) => {
            return {
                field: k,
                value: mockInfo[k]!.toString(),
            };
        });

        const personas = (((state as State).workingSet['root'] as TrackedRecord).value['personas'] as TrackedArray);
        const existingPersonaIndex = personas.value.findIndex((persona: any) => persona.value.name.value === activePersonaName);

        if (existingPersonaIndex !== -1) {
            const updatedPersona = createFromRawValue(state as State, {
                kind: 'Persona',
                name: activePersonaName,
                attrs: personaAttrs,
            });

            personas.remove(existingPersonaIndex);
            personas.insert(existingPersonaIndex, updatedPersona);
        }
        setShowModal(false);
    }

    return <>
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{activePersonaName ? 'Update Persona' : 'Save New Persona'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    {activePersonaName ? (
                        <p className="h4 mb-2">Updating {activePersonaName}</p>
                    ) : (
                        <>
                            <p className="h4 mb-2">Please enter persona name:</p>
                            <input 
                                className="form-control"
                                type="text" 
                                value={newPersonaName} 
                                onChange={(e) => setNewPersonaName(e.target.value)}
                            />
                        </>
                    )}
                </div>
                
                <div className="mt-4">
                    <p className="h5 mb-2">Persona Attributes</p>
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Target Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(mockInfo).map((key, index) => (
                                <tr key={index}>
                                    <td>{key}</td>
                                    <td>{mockInfo[key]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button 
                    className="btn btn-primary" 
                    onClick={() => activePersonaName ? updateActivePersona() : saveNewPersona()}
                >
                    {activePersonaName ? 'Update' : 'Save'}
                </button>
                <button 
                    className="btn btn-secondary" 
                    onClick={() => setShowModal(false)}
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    </>;
}